export default __webpack_public_path__ + "static/media/storyMarker.aedc7728.png";